<script setup lang="ts">
import type { FieldProps } from './interface'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/components/ui/form'
import AutoFormLabel from './AutoFormLabel.vue'
import { beautifyObjectName } from './utils'
import {
  PinInput,
  PinInputGroup,
  PinInputInput,
} from '@/components/ui/pin-input'
import { nextTick, onMounted, ref } from 'vue'

const randomId = `pin-root-${Math.random().toString(36).substring(2, 15)}`;
const pinModel = ref<string[]>([])
const props = defineProps<FieldProps>()

// @ts-ignore
const length = props.config?.inputProps?.length ?? 5;

// @ts-ignore — callers use autoFocus; HTML uses autofocus
const shouldAutoFocus = Boolean(
  // (props.config?.inputProps as any)?.autoFocus ??
  props.config?.inputProps?.autofocus
);

const focusFirstInput = async () => {
  const pinRootEl = document.getElementById(randomId);
  if (!pinRootEl) return;
  const inputs = pinRootEl?.querySelectorAll<HTMLInputElement>('input');
  if (!inputs.length) return;
  inputs[0]?.focus();
}

onMounted(async () => {
  if (!shouldAutoFocus) return;
  await new Promise(resolve => setTimeout(resolve, 100));
  // Pin mounts after form/dialog layout; native autofocus is unreliable on dynamic mounts
  const focusFirst = async () => {
    const pinRootEl = document.getElementById(randomId);
    if (!pinRootEl) return;
    const inputs = pinRootEl?.querySelectorAll<HTMLInputElement>('input');
    if (!inputs.length) return;
    const firstInput = inputs[0];
    let count = 0;
    while (document.activeElement !== firstInput && count < 20) {
      focusFirstInput();
      await new Promise(resolve => setTimeout(resolve, 100));
      count++;
    }
    // focusFirstInput();
  };
  // setTimeout(focusFirst, 200);
  focusFirst();
});

async function onPinComplete(value: string[], handleChange: (v: string) => void) {
  handleChange(value.join(''));
  await nextTick();
  document.getElementById(randomId)?.closest('form')?.requestSubmit();
}
</script>

<template>
  <FormField v-slot="slotProps"
             :name="fieldName">
    <FormItem>
      <div class="space-y-0 mb-3 flex items-center gap-3">
        <AutoFormLabel v-if="!config?.hideLabel"
                       :required="required">
          {{ config?.label || beautifyObjectName(label ?? fieldName) }}
        </AutoFormLabel>
        <FormControl>
          <slot v-bind="slotProps">
            <div :id="randomId">
              <PinInput :disabled="disabled"
                        placeholder="○"
                        class="flex gap-2 items-center mt-1"
                        otp
                        type="number"
                        @complete="(e: string[]) => onPinComplete(e, slotProps.handleChange)"
                        @update:modelValue="(arrStr: string[]) => {
                          slotProps.handleChange(arrStr.filter(Boolean).join(''))
                        }"
                        v-model="pinModel">
                <PinInputGroup>
                  <PinInputInput v-for="(id, index) in length"
                                 :key="id"
                                 :index="index" />
                </PinInputGroup>
              </PinInput>
            </div>
          </slot>
        </FormControl>

      </div>

      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
